// extracted by mini-css-extract-plugin
module.exports = {"container":"FiltersRelation_container__27mA7"};